/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon64Regular = forwardRef('MediaUiAPauseIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M24 10.5a1.5 1.5 0 0 0-3 0v43a1.5 1.5 0 0 0 3 0v-43Z" }),
        React.createElement("path", { d: "M43 10.5a1.5 1.5 0 0 0-3 0v43a1.5 1.5 0 0 0 3 0v-43Z" })));
});
